import { render } from "./HotkeysHelper.vue?vue&type=template&id=ef1e5be2&lang=pug"
import script from "./HotkeysHelper.vue?vue&type=script&lang=js"
export * from "./HotkeysHelper.vue?vue&type=script&lang=js"

import "./HotkeysHelper.vue?vue&type=style&index=0&id=ef1e5be2&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/sd-app-pipe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__